module.exports = __webpack_public_path__ + "img/horizontal_3_6_pp13_7016.51396b30.png";